import { useFormContext, useWatch } from 'react-hook-form'

import { BaseRepresentanteLegalForm } from '@/features/proposta/brasil/components/ui'
import type { CompradorPessoaJuridicaSchemaInput } from '@/features/proposta/brasil/domain/schemas/compradores/comprador-pj.schema'
import { useClientePorCpfProposta } from '@/features/proposta/brasil/hooks/use-cliente-por-cpf-proposta'
import { useDadosRepresentanteLegal } from '@/features/proposta/brasil/hooks/use-dados-representante-legal'
import type { TCompradoresCadastrados } from '@/features/proposta/brasil/types/proposta.type'
import type { TNacionalidade, TProfissao } from '@/types/cliente'

type TDadosComprador = {
  onBack: () => void
  onNext: () => void
  compradores: TCompradoresCadastrados
  nacionalidades: TNacionalidade[]
  profissoes: TProfissao[]
}

export const DadosRepresentanteLegal = ({
  onNext,
  onBack,
  compradores,
  nacionalidades,
  profissoes,
}: TDadosComprador) => {
  const {
    formState: { errors },
    control,
  } = useFormContext<CompradorPessoaJuridicaSchemaInput>()

  const cpf = (useWatch({ name: 'responsavel.dados.cpf' }) ?? '') as string
  const buscouCpf = !!useWatch({ name: 'responsavel.dados.buscouCpf' })
  const cpfRaw = cpf?.replaceAll(/\D/g, '')
  const cpfError = errors?.responsavel?.dados?.cpf
  const isEditing = useWatch({ name: 'mode' }) === 'edit'
  const nacionalidadePrincipalId = nacionalidades[0]?.id ?? ''

  const { refetch, isFetching } = useClientePorCpfProposta(String(cpfRaw), false)
  const { handlers } = useDadosRepresentanteLegal({
    onNext,
    compradores,
    refetch,
    nacionalidadePrincipalId,
  })

  return (
    <BaseRepresentanteLegalForm
      onBack={onBack}
      onNext={onNext}
      compradores={compradores}
      nacionalidades={nacionalidades}
      profissoes={profissoes}
      control={control}
      fields={{
        cpf: 'responsavel.dados.cpf',
        nome: 'responsavel.dados.nome',
        nacionalidadeId: 'responsavel.dados.nacionalidadeId',
        profissaoId: 'responsavel.dados.profissaoId',
      }}
      isEditing={isEditing}
      cpf={cpf}
      buscouCpf={buscouCpf}
      cpfError={cpfError}
      isFetching={isFetching}
      handlers={handlers}
    />
  )
}
